'use strict';

exports.__esModule = true;
exports.transformPractices = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns true if the practice is valid, that is if it's approved or verified.
 * @param {!Object} practice A practice.
 * @return {boolean} true if the practice status is approved or verified.
 */
var isValidPractice = function isValidPractice(practice) {
	return ['approved', 'verified'].includes(practice.practice_status);
};

var transformPractices = exports.transformPractices = function transformPractices() {
	var practices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	return practices.filter(isValidPractice).map(function (practice) {
		var location = void 0;
		if (practice.practice && practice.practice && practice.practice.address && practice.practice.address.geolocation) {
			var geolocation = (JSON.parse(practice.practice.address.geolocation) || {}).coordinates;
			location = {
				lat: geolocation.length ? geolocation[1] : undefined,
				lng: geolocation.length ? geolocation[0] : undefined
			};
		}

		return {
			postcode: practice.practice.address.postcode,
			street1: practice.practice.address.street1,
			city: practice.practice.address.city,
			uriId: practice.practice.uri_id,
			name: practice.practice.name,
			id: practice.practice.id,
			location: location
		};
	});
};